import { useMemo } from 'react';
import { CONTRACT_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import { useRenewalAction } from '../renewal/useRenewalAction';
import { useChangeContractAction } from '../change/useChangeContractAction';
import { ContractActions } from '../types';
import { useCancelTerminationAction } from '../cancel-termination/useCancelTerminationAction';
import { useTerminateAction } from '../terminate/useTerminateAction';
import { useUpdatePaymentMethodAction } from '../update-payment-method/useUpdatePaymentMethodAction';
import { useManageTerminationAction } from '../manage-termination/useManageTerminationAction';
import { useDeleteContractAction } from '../delete/useDeleteContractAction';
import { useFetchContractData } from '../../../hooks/useFetchContractData';
import { useFetchAllowedActions } from './useAllowedActions';
export function useContractActions({
  objectId,
  objectTypeId,
  skipAll
}) {
  const skip = skipAll || !objectId || objectId === -1 || objectTypeId !== CONTRACT_TYPE_ID;
  useFetchContractData({
    objectId,
    objectTypeId
  }, {
    skip
  });
  useFetchAllowedActions({
    objectId,
    objectTypeId
  }, {
    skip
  });
  const terminateAction = useTerminateAction({
    objectId,
    objectTypeId,
    skip
  });
  const changeAction = useChangeContractAction({
    objectId,
    objectTypeId,
    skip
  });
  const renewalAction = useRenewalAction({
    objectId,
    objectTypeId,
    skip
  });
  const cancelTerminationAction = useCancelTerminationAction({
    objectId,
    objectTypeId,
    skip
  });
  const updatePaymentMethodAction = useUpdatePaymentMethodAction({
    objectId,
    objectTypeId,
    skip
  });
  const manageTerminationAction = useManageTerminationAction({
    objectId,
    objectTypeId,
    skip
  });
  const deleteAction = useDeleteContractAction({
    objectId,
    objectTypeId,
    skip
  });
  return useMemo(() => {
    return {
      [ContractActions.UPDATE_PAYMENT_METHOD]: updatePaymentMethodAction,
      [ContractActions.CREATE_CHANGE_QUOTE]: changeAction,
      [ContractActions.CREATE_RENEWAL_QUOTE]: renewalAction,
      [ContractActions.RESCHEDULE_TERMINATION]: manageTerminationAction,
      [ContractActions.CANCEL_TERMINATION]: cancelTerminationAction,
      [ContractActions.TERMINATE]: terminateAction,
      [ContractActions.DELETE_CONTRACT]: deleteAction
    };
  }, [updatePaymentMethodAction, changeAction, renewalAction, manageTerminationAction, cancelTerminationAction, terminateAction, deleteAction]);
}
export function useContractActionsList({
  objectId,
  objectTypeId
}) {
  const actions = useContractActions({
    objectId,
    objectTypeId
  });
  return useMemo(() => {
    var _actions$UPDATE_PAYME, _actions$CREATE_CHANG, _actions$CREATE_RENEW, _actions$RESCHEDULE_T, _actions$CANCEL_TERMI, _actions$TERMINATE, _actions$DELETE_CONTR;
    const actionsList = [...((_actions$UPDATE_PAYME = actions.UPDATE_PAYMENT_METHOD) !== null && _actions$UPDATE_PAYME !== void 0 && _actions$UPDATE_PAYME.isAvailable() ? [actions.UPDATE_PAYMENT_METHOD] : []), ...((_actions$CREATE_CHANG = actions.CREATE_CHANGE_QUOTE) !== null && _actions$CREATE_CHANG !== void 0 && _actions$CREATE_CHANG.isAvailable() ? [actions.CREATE_CHANGE_QUOTE] : []), ...((_actions$CREATE_RENEW = actions.CREATE_RENEWAL_QUOTE) !== null && _actions$CREATE_RENEW !== void 0 && _actions$CREATE_RENEW.isAvailable() ? [actions.CREATE_RENEWAL_QUOTE] : [])];
    if (actionsList.length > 0) {
      actionsList.push('divider');
    }
    return [...actionsList, ...((_actions$RESCHEDULE_T = actions.RESCHEDULE_TERMINATION) !== null && _actions$RESCHEDULE_T !== void 0 && _actions$RESCHEDULE_T.isAvailable() ? [actions.RESCHEDULE_TERMINATION] : []), ...((_actions$CANCEL_TERMI = actions.CANCEL_TERMINATION) !== null && _actions$CANCEL_TERMI !== void 0 && _actions$CANCEL_TERMI.isAvailable() ? [actions.CANCEL_TERMINATION] : []), ...((_actions$TERMINATE = actions.TERMINATE) !== null && _actions$TERMINATE !== void 0 && _actions$TERMINATE.isAvailable() ? [actions.TERMINATE] : []), ...((_actions$DELETE_CONTR = actions.DELETE_CONTRACT) !== null && _actions$DELETE_CONTR !== void 0 && _actions$DELETE_CONTR.isAvailable() ? [actions.DELETE_CONTRACT] : [])];
  }, [actions.CANCEL_TERMINATION, actions.CREATE_CHANGE_QUOTE, actions.CREATE_RENEWAL_QUOTE, actions.DELETE_CONTRACT, actions.RESCHEDULE_TERMINATION, actions.TERMINATE, actions.UPDATE_PAYMENT_METHOD]);
}